import {
  FETCH_CATALOGUE_ERROR,
  FETCH_CATALOGUE_PENDING,
  FETCH_CATALOGUE_SUCCESS,
} from "../actions/catalogue";

const initialState = {
  pending: false,
  data: null,
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_CATALOGUE_PENDING:
      return {
        ...state,
        pending: true,
      };
    case FETCH_CATALOGUE_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.payload,
        error: null,
      };
    case FETCH_CATALOGUE_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
        data: null,
      };
    default:
      return state;
  }
}
